import React, { Fragment, useState, useEffect } from 'react';
import CustomTable from '@jumbo/components/CustomTable';
import PageLoader from '@jumbo/components/custom/Spinner/pageLoader';
import { Visibility, Delete } from '@material-ui/icons';
import VerReclamo from '../VerReclamo';
import QuitReclamo from '../QuitReclamo';
import Spinner from '@jumbo/components/custom/Spinner';
// import GetReclamo from '../GetReclamo';
import { API_EXTRANET } from 'config/config';
import { validacionPermit } from '../../../../../services/service.user';
import axios from 'axios';
import { CustomToast } from '@jumbo/components/custom/Toast';

const headCells = [
  {
    id: 'n_reclamo',
    numeric: false,
    disablePadding: false,
    align: 'left',
    alignContent: 'left',
    label: 'N° Reclamo',
  },
  { id: 'fechaIngreso', alignContent: 'left', label: 'Fecha Ingreso' },
  { id: 'tipo', alignContent: 'left', label: 'Tipo' },
  { id: 'nombre_rec', alignContent: 'left', label: 'Reclamante' },
  { id: 'run_pac', alignContent: 'left', label: 'Rut' },
  { id: 'etapa_actual', alignContent: 'left', label: 'Etapa' },
];

const validaciones = [
  {
    type: 'dateRange',
    target: 'fechaIngreso',
    title: 'Fecha',
  },
];

const actions = [
  { action: 'ver', label: 'Ver', icon: <Visibility /> },
  { action: 'quitar', label: 'Quitar', icon: <Delete /> },
];

const TablaReclamosPendientes = () => {
  const [primeraCarga, setPrimeraCarga] = useState(false);
  const [entidadesList, setEntidadesList] = useState([]);
  const [showVerReclamo, setShowVerReclamo] = useState(false);
  const [reclamoVer, setReclamoVer] = useState(null);
  const [showQuitarReclamo, setShowQuitarReclamo] = useState(false);
  const [reclamoQuitar, setReclamoQuitar] = useState(null);
  const [spinner, setSpinner] = useState(false);

  const loadEntidades = () => {
    /* const user = JSON.parse(sessionStorage.getItem('user')); */
    axios
      .get(`${API_EXTRANET}api/v1/userIp?indice=mediaciones`, {
        headers: {
          Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
        },
      })
      .then(res => {
        setEntidadesList(
          res.data.map(entidad => {
            return {
              ...entidad,
              fechaIngreso: entidad.fecha_ingreso.split('/').join('-'),
            };
          }),
        );
        //setSpinner(false);
        setPrimeraCarga(true);
      })
      .catch(err => {
        //setSpinner(false);
        console.log(err);
      })
      .finally(e => {
        setSpinner(false);
      });
  };

  useEffect(() => {
    loadEntidades();
  }, []);

  const handleAction = (menu, item) => {
    if (menu.action === 'ver') {
      setReclamoVer(item);
      setShowVerReclamo(true);
    }
    if (menu.action === 'quitar') {
      setReclamoQuitar(item);
      setShowQuitarReclamo(true);
    }
  };

  const verReclamoClose = () => {
    setShowVerReclamo(false);
    setReclamoVer(null);
  };

  const quitarReclamoClose = () => {
    setShowQuitarReclamo(false);
    setReclamoQuitar(null);
  };

  const quitarReclamoSubmit = () => {
    setShowQuitarReclamo(false);
    setReclamoQuitar(null);
    setSpinner(true);
    loadEntidades();
  };

  return (
    validacionPermit('search_reclaim_ip') && (
      <Fragment>
        <Spinner show={spinner} />
        <CustomToast />
        <VerReclamo openDialog={showVerReclamo} close={verReclamoClose} reclamo={reclamoVer} />
        <QuitReclamo
          openDialog={showQuitarReclamo}
          close={quitarReclamoClose}
          reclamo={reclamoQuitar}
          submit={quitarReclamoSubmit}
        />

        {primeraCarga ? (
          entidadesList.length === 0 ? (
            <h1 style={{ marginLeft: 16 }}>Usted no tiene reclamos asignados</h1>
          ) : (
            <CustomTable
              headCells={headCells}
              rows={entidadesList}
              title={'Reclamos'}
              validation={validaciones}
              search={true}
              actions={actions}
              handleAction={handleAction}
            />
          )
        ) : (
          <PageLoader />
        )}
      </Fragment>
    )
  );
};

export default TablaReclamosPendientes;
